import { ValidationError } from "yup";

import {
  DespatchTruck,
  DespatchProduct,
  DespatchShippingItem,
} from "../../../../../models/despatch";
import { DespatchFields } from "../../../../../util/enums";

export interface DespatchProductToSearch extends DespatchProduct {
  [x: string]: any;
}

export interface DespatchShippingItemToSearch extends DespatchShippingItem {
  [x: string]: any;
}

export interface DespatchTruckToSearch extends DespatchTruck {
  [x: string]: any;
}

export interface DespatchSectionsProps {
  fieldHasError: (field: string) => boolean;
  getErrorByField: (field: string) => string | undefined;
  generateBaseFieldProps: (name: DespatchFields) => BaseFieldProps;
  viewOnly?: boolean;
  errors?: ValidationError[];
}

export interface BaseFieldProps {
  error: boolean;
  errorMessage: string | undefined;
  "data-cy": string;
  dataCy: string;
  label: string;
  placeholder: string;
  "aria-label": DespatchFields;
  disabled: boolean | undefined;
  name: DespatchFields;
}

export enum DespatchObjects {
  DESPATCH = "despatch",
  PRODUCTS = "products",
  SHIPPING_ITEMS = "shippingItems",
  TRUCK = "truck",
}
export interface DespatchChangeKeys {
  [DespatchObjects.DESPATCH]: boolean;
  [DespatchObjects.PRODUCTS]: boolean;
  [DespatchObjects.SHIPPING_ITEMS]: boolean;
  [DespatchObjects.TRUCK]: boolean;
}

export type DespatchChangeOptions = DespatchObjects;
